import { keepPreviousData, useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IMergeTicketsRequest, ITicket } from "../../models/Tickets/Ticket";
import { TicketQueryKeys } from "./keys";

/**
 * The ticket a merge would create, built by the API without saving anything -
 * so the preview is exactly what the merge produces. Its attachments are still
 * the originals on their own tickets.
 */
export default function useTicketMergePreview(
  ticketIds: string[],
  subject: string,
  enabled: boolean,
) {
  const { post } = useApiHelper();

  const preview = useQuery({
    queryKey: TicketQueryKeys.mergePreview(ticketIds, subject),
    queryFn: () =>
      post<IDefaultResponse<ITicket>, IMergeTicketsRequest>(
        `/ticket/merge/preview`,
        { ticketIds, subject },
      ).then((res) => res.data),
    enabled: enabled && ticketIds.length > 0,
    // Keeps the thread on screen while the subject is retyped.
    placeholderData: keepPreviousData,
  });

  return {
    preview,
  };
}
